import * as sentry from '@sentry/nextjs';
import React, { useCallback, useEffect } from 'react';

import { useAuth } from '../../../../providers';
import { useCreateSignatureForListingMutation } from '../../../../types/generated';
import { network, WidgetProps } from '../config';

// https://docs.manifold.xyz/v/manifold-for-developers/resources/widgets/marketplace-widgets/widgets/listing-widgets#m-listing-bid-form-rich
export const BidFormRich = ({ listingId }: WidgetProps) => {
  const { user } = useAuth();
  const [createSignature] = useCreateSignatureForListingMutation();

  const handleVerifyIdentity = useCallback(
    (event: CustomEvent<{ transactionId: string; buyerAddress: string }>) => {
      if (!user?.email || !listingId) return;

      createSignature({
        variables: {
          input: {
            walletAddress: event.detail.buyerAddress,
            listingId: Number(listingId),
          },
        },
      })
        .then(({ data: response }) => {
          if (!response?.createSignatureForBlockchainAuctionListing) return;

          const e = new CustomEvent('m-marketplace_tx_id_complete', {
            detail: {
              transactionId: event.detail.transactionId,
              verified: true,
              identityVerifierData:
                response.createSignatureForBlockchainAuctionListing,
            },
          });
          window.dispatchEvent(e);
        })
        .catch((err) => {
          sentry.captureException(err);
        });
    },
    [listingId, user],
  );

  useEffect(() => {
    window.addEventListener('m-marketplace_tx_id_verify', handleVerifyIdentity);
    return () => {
      window.removeEventListener(
        'm-marketplace_tx_id_verify',
        handleVerifyIdentity,
      );
    };
  }, [handleVerifyIdentity]);

  /**
   * window.mMarketplaceStore.subscribeAction((action, state) => {
   *   console.log(action.type)
   *   console.log(action.payload)
   * })
   */

  return (
    <div
      data-emits-identity-verify="true"
      data-id={listingId}
      data-network={network}
      data-widget="m-listing-bid-form-rich"
      id="bid-form"
    />
  );
};
